if ( typeof InfoTabs !== 'function' ) {

	class InfoTabs extends HTMLElement {

		constructor(){

			super();

			this.tabs = this.querySelectorAll('.js-info-tab');
			this.panels = this.querySelectorAll('.js-info-panel');
			this.panelsContainer = this.querySelector('.info-tabs_panels');
			this.togglers = this.querySelector('.info-tabs_togglers');
			this.index = 0;
			this.timeout = null;
			this._timeoutInterval = parseInt(this.dataset.tabsAutoplayTimer*1000);

			this.mobileNav = document.querySelectorAll(`#info-tabs-navigation-${this.dataset.id} .css-slider-dot`);
			this.mobileNavPrev = document.querySelector(`#info-tabs-navigation-${this.dataset.id} .css-slider-prev`);
			this.mobileNavNext = document.querySelector(`#info-tabs-navigation-${this.dataset.id} .css-slider-next`);

			this.zIndex = 99;
			this._autoplaySetting = this.dataset.tabsAutoplay;

			this.scrollSpy = this.dataset.tabsScrollSpy == 'true' && this.tabs.length > 1;
			if ( this.scrollSpy ) {
				this.dataset.tabsAutoplay = "false";
			}

			if ( window.innerWidth < 768 ) {
				this.dataset.tabsAutoplay = "false";
			}

			if (this.dataset.tabsAutoplay == "true" && this.tabs.length > 1 ) {
				this.#autoplay(this._timeoutInterval, true);
				this.togglers.addEventListener('mouseover', () => {
					if ( this.timeout > 0 ) {
						this._timeoutRemaining = this._timeoutInterval - (new Date().getTime() - this._timeoutStart);
						clearTimeout(this.timeout);
						this.timeout = 0;
					}
				});

				this.togglers.addEventListener('mouseleave', () => {
					this.#autoplay(this._timeoutRemaining, true);
					this._timeoutInterval = this._timeoutRemaining;
				});

			}

			this.index = 0;
			this.SCROLL_EVENT = debounce(()=>{
				if ( ! this._blockScroll ) {
					const scrollItems = this.tabs.entries();
					const scrollArray = Array.from(scrollItems, elm => (elm[1].offsetLeft-this.togglers.scrollLeft) + elm[1].offsetWidth);
					const scrollIndex = scrollArray.reduce((bestIdx, current, idx) => {
						return (current <= window.innerWidth && (bestIdx === -1 || Math.abs(scrollArray[bestIdx] - window.innerWidth) > Math.abs(current - window.innerWidth))) ? idx : bestIdx;
					}, -1);
					if ( scrollIndex != this.index ) {
						this.index = scrollIndex;
						this.#clickTab(this.tabs[this.index]);
					}
				}
			}, 10);

			this.togglers.addEventListener('scroll', this.SCROLL_EVENT, {passive:true});

			this.tabs.forEach(tab => {
				tab.addEventListener('click', e=>{
					if ( ! e.currentTarget.classList.contains('active') ) {
						this.#clickTab(e.currentTarget);
						if ( window.innerWidth < 768 ) {
							this.togglers.scrollTo({
								left: e.currentTarget.offsetLeft - 40,
								behavior: 'smooth'
							});
						}
					}
				});
			});

			if ( this.mobileNavPrev ) {
				this.mobileNavPrev.addEventListener('click', ()=>{
					if ( this.index - 1 >= 0 ) {
						this.index--;
						this.#clickTab(this.tabs[this.index]);
						this.togglers.scrollTo({
							left: this.tabs[this.index].offsetLeft - 40,
							behavior: 'smooth'
						});
					}
				});
			}

			if ( this.mobileNavNext ) {
				this.mobileNavNext.addEventListener('click', ()=>{
					if ( this.index + 1 < this.tabs.length ) {
						this.index++;
						this.#clickTab(this.tabs[this.index]);
						this.togglers.scrollTo({
							left: this.tabs[this.index].offsetLeft - 40,
							behavior: 'smooth'
						});
					}
				});
			}

			// desktop: switch tabs with the mouse wheel; release the page scroll at either end
			if ( this.dataset.tabsWheel == 'true' && this.tabs.length > 1 && ! this.scrollSpy ) {
				this.WHEEL_EVENT = (e) => {
					if ( window.innerWidth < 768 || this._blockScroll || this._stacked ) return;
					const atFirst = this.index === 0;
					const atLast = this.index + 1 >= this.tabs.length;
					if ( e.deltaY > 0 && ! atLast ) {
						e.preventDefault();
						this.#clickTab(this.tabs[this.index + 1]);
					} else if ( e.deltaY < 0 && ! atFirst ) {
						e.preventDefault();
						this.#clickTab(this.tabs[this.index - 1]);
					}
				};
				this.addEventListener('wheel', this.WHEEL_EVENT, {passive:false});
			}

			// desktop: page scroll drives tab switching, tabs stay centered on screen
			if ( this.scrollSpy ) {
				this.scrollContainer = this.closest('.info-tabs-scroll-container');
				if ( this.scrollContainer ) {
					this.SCROLLSPY_EVENT = () => this.#scrollSpyUpdate();
					this.SCROLLSPY_RESIZE = debounce(() => this.#sizeScrollSpy(), 150);
					window.addEventListener('scroll', this.SCROLLSPY_EVENT, {passive:true});
					window.addEventListener('resize', this.SCROLLSPY_RESIZE);
					window.addEventListener('load', this.SCROLLSPY_RESIZE);
					this.#sizeScrollSpy();
					this.#scrollSpyUpdate();
					this.tabs.forEach(tab => {
						tab.addEventListener('click', () => {
							if ( window.innerWidth >= 768 && ! this._stacked ) {
								this.#scrollToTab(parseInt(tab.dataset.index));
							}
						});
					});
				}
			}

			// mobile: stack all tabs open (image moved under its title/caption)
			this._stacked = false;
			if ( this.panelsContainer && window.matchMedia ) {
				this.MOBILE_MEDIA = window.matchMedia('(max-width: 767px)');
				this.MEDIA_EVENT = (e) => this.#setupLayout(e.matches);
				if ( this.MOBILE_MEDIA.addEventListener ) {
					this.MOBILE_MEDIA.addEventListener('change', this.MEDIA_EVENT);
				}
				this.#setupLayout(this.MOBILE_MEDIA.matches);
			}

		}

		#scrollSpyUpdate() {
			if ( window.innerWidth < 768 || this._stacked || ! this.scrollContainer ) return;
			const rect = this.scrollContainer.getBoundingClientRect();
			if ( rect.bottom < 0 || rect.top > window.innerHeight ) return;
			const total = rect.height - window.innerHeight;
			if ( total <= 0 ) return;
			let progress = (-rect.top) / total;
			progress = Math.min(1, Math.max(0, progress));
			const idx = Math.round(progress * (this.tabs.length - 1));
			if ( idx != this.index && ! this._blockScroll ) {
				this.#clickTab(this.tabs[idx]);
			}
		}

		#sizeScrollSpy() {
			if ( ! this.scrollContainer ) return;
			if ( window.innerWidth < 768 || this._stacked ) {
				this.scrollContainer.style.minHeight = '';
				this.classList.remove('info-tabs--scrollspy');
				this.style.removeProperty('top');
				return;
			}
			this.scrollContainer.style.minHeight = '';
			const segment = Math.max(200, Math.round(window.innerHeight * 0.5));
			const extra = (this.tabs.length - 1) * segment;
			this.scrollContainer.style.minHeight = (this.scrollContainer.offsetHeight + extra) + 'px';
			const top = Math.max(80, Math.round(window.innerHeight / 2 - this.offsetHeight / 2));
			this.classList.add('info-tabs--scrollspy');
			this.style.top = top + 'px';
		}

		#scrollToTab(idx) {
			if ( ! this.scrollContainer || this.tabs.length < 2 ) return;
			const rect = this.scrollContainer.getBoundingClientRect();
			const total = rect.height - window.innerHeight;
			if ( total <= 0 ) return;
			const p = idx / (this.tabs.length - 1);
			window.scrollTo({
				top: window.scrollY + rect.top + p * total,
				behavior: 'smooth'
			});
		}

		#setupLayout(stacked) {
			if ( stacked === this._stacked ) return;
			this._stacked = stacked;
			if ( stacked ) {
				this.classList.add('info-tabs--stacked');
				this.dataset.tabsAutoplay = "false";
				this.tabs.forEach(tab => {
					const panel = document.getElementById(`panel-${tab.getAttribute('rel')}`);
					if ( panel ) tab.appendChild(panel);
				});
			} else {
				this.classList.remove('info-tabs--stacked');
				this.dataset.tabsAutoplay = this._autoplaySetting;
				this.panels.forEach(panel => this.panelsContainer.appendChild(panel));
				if ( this.dataset.tabsAutoplay == "true" && this.tabs.length > 1 && ! this.timeout ) {
					this._timeoutInterval = parseInt(this.dataset.tabsAutoplayTimer*1000);
					this.#autoplay(this._timeoutInterval, true);
				}
			}
			if ( this.scrollSpy ) {
				this.#sizeScrollSpy();
			}
		}

		#clickTab(tab) {

			const panelID = tab.getAttribute('rel');
			const panel = document.getElementById(`panel-${panelID}`);
			this.reset();

			this.index = parseInt(tab.dataset.index);
			tab.classList.add('active');

			this.#slideDown(tab.querySelector('.info-tabs__tab-caption'), 200);

			if ( panel && ! this._stacked ) {
				panel.classList.add('active');
				panel.style.zIndex = ++this.zIndex;
				panel.style.opacity = 1;
			}

			this.mobileNav.forEach((elm, index) => {
				if ( index == this.index ) {
					elm.classList.add('active');
				} else {
					elm.classList.remove('active');
				}
			});
			if ( this.mobileNavNext ) {
				this.mobileNavNext.classList.remove('disabled');
				this.mobileNavPrev.classList.remove('disabled');
				if ( this.index == 0 ) {
					this.mobileNavPrev.classList.add('disabled');
				} else if ( this.index + 1 == this.tabs.length ) {
					this.mobileNavNext.classList.add('disabled');
				}
			}

      this._blockScroll = true;
      setTimeout(()=>{
        this._blockScroll = false;
      }, 500);

		}

		#autoplay(delay, reset = false) {
			if ( reset ) {
				this._timeoutStart = new Date().getTime();
			}
			this.timeout = setTimeout(()=>{
				if (this.index + 1 >= this.tabs.length) {
					this.index = 0;
				} else {
					this.index++;
				}
				this.tabs[this.index].click();
				this._timeoutInterval = parseInt(this.dataset.tabsAutoplayTimer*1000);
				this.#autoplay(this._timeoutInterval, true);
			}, delay);
		}

		disconnectedCallback() {
			clearTimeout(this.timeout);
			if ( this.togglers && this.SCROLL_EVENT ) {
				this.togglers.removeEventListener('scroll', this.SCROLL_EVENT);
			}
			if ( this.WHEEL_EVENT ) {
				this.removeEventListener('wheel', this.WHEEL_EVENT);
			}
			if ( this.SCROLLSPY_EVENT ) {
				window.removeEventListener('scroll', this.SCROLLSPY_EVENT);
			}
			if ( this.SCROLLSPY_RESIZE ) {
				window.removeEventListener('resize', this.SCROLLSPY_RESIZE);
				window.removeEventListener('load', this.SCROLLSPY_RESIZE);
			}
			if ( this.MOBILE_MEDIA && this.MOBILE_MEDIA.removeEventListener && this.MEDIA_EVENT ) {
				this.MOBILE_MEDIA.removeEventListener('change', this.MEDIA_EVENT);
			}
		}

		reset() {
			clearTimeout(this.timeout);
			this._timeoutInterval = parseInt(this.dataset.tabsAutoplayTimer*1000);
			this._timeoutRemaining = this._timeoutInterval;
			this.querySelectorAll('.active').forEach(elm => {
				if ( elm.querySelector('.info-tabs__tab-caption') ) {
					this.#slideUp(elm.querySelector('.info-tabs__tab-caption'), 200);
				}
				if ( ! this._stacked ) {
					elm.classList.remove('active');
				}
			});
		}

		#slideUp(target, duration){
			if ( window.innerWidth >= 768 ) {
				target.style.transitionProperty = 'height, margin, padding';
				target.style.transitionDuration = duration + 'ms';
				target.style.boxSizing = 'border-box';
				target.style.height = target.offsetHeight + 'px';
				target.offsetHeight;
				target.style.overflow = 'hidden';
				target.style.height = 0;
				target.style.paddingTop = 0;
				target.style.paddingBottom = 0;
				target.style.marginTop = 0;
				target.style.marginBottom = 0;
				setTimeout(()=>{
					target.style.display = 'none';
					target.style.removeProperty('height');
					target.style.removeProperty('padding-top');
					target.style.removeProperty('padding-bottom');
					target.style.removeProperty('margin-top');
					target.style.removeProperty('margin-bottom');
					target.style.removeProperty('overflow');
					target.style.removeProperty('transition-duration');
					target.style.removeProperty('transition-property');
				}, duration);
			}
		}
		#slideDown(target, duration) {
			if ( window.innerWidth >= 768 ) {
				target.style.removeProperty('display');
				var display = window.getComputedStyle(target).display;

				if (display === 'none')
					display = 'block';

				target.style.display = display;
				var height = target.offsetHeight;
				target.style.overflow = 'hidden';
				target.style.height = 0;
				target.style.paddingTop = 0;
				target.style.paddingBottom = 0;
				target.style.marginTop = 0;
				target.style.marginBottom = 0;
				target.offsetHeight;
				target.style.boxSizing = 'border-box';
				target.style.transitionProperty = "height, margin, padding";
				target.style.transitionDuration = duration + 'ms';
				target.style.height = height + 'px';
				target.style.removeProperty('padding-top');
				target.style.removeProperty('padding-bottom');
				target.style.removeProperty('margin-top');
				target.style.removeProperty('margin-bottom');
				setTimeout(()=>{
					target.style.removeProperty('height');
					target.style.removeProperty('overflow');
					target.style.removeProperty('transition-duration');
					target.style.removeProperty('transition-property');
				}, duration);
			}
		}

	}

  if ( typeof customElements.get('info-tabs') == 'undefined' ) {
    customElements.define('info-tabs', InfoTabs);
	}

}
